import { useNavigate } from 'react-router'
import Card from '../../components/common/Card'
import PageMeta from '../../components/common/PageMeta'
import DefaultTable from '../../components/tables/DefaultTable/DefaultTable'
import Switch from '../../components/form/switch/Switch'
import { useCreate } from '../../context/CreateRegisterContext'
import { ProductDataType, useProduct } from '../../context/ProductContext'
import ProductForm from './ProductForm'
import Badge from '../../components/ui/badge/Badge'

export default function Product() {
    const navigate = useNavigate()
    const { openProduct, setOpenProduct } = useCreate()
    const { products, setProductDefault } = useProduct()

    const rows = products.map(product => ({
        ...product,
        defaultControl: product?.isDefault ? <Badge color='primary'>Padrão</Badge> : '--',
        businessLabel:
            product.businessCount === 1 ? '1 negócio vinculado' : `${product.businessCount} negócios vinculados`
    }))

    const columns = [
        { key: 'id', label: '#' },
        { key: 'name', label: 'Nome do produto' },
        { key: 'businessLabel', label: 'Vínculos' },
        { key: 'defaultControl', label: 'Padrão' }
    ]

    const handleClick = (row: ProductDataType) => navigate(`/produto/${row.id}`)

    return (
        <>
            <PageMeta title='Produtos | CRM' description='Lista todos os produtos' />
            <div className='space-y-6'>
                <Card>
                    <DefaultTable
                        columns={columns}
                        rows={rows}
                        rowsPerPage={20}
                        handleClick={handleClick}
                        handleCreate={() => setOpenProduct(true)}
                    />
                </Card>
            </div>
            <ProductForm type='create' open={openProduct} handleClose={() => setOpenProduct(false)} />
        </>
    )
}
